import { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ContractorTaxTypePlugin } from './ContractorTaxTypePlugin';

interface IContractorTaxTypePluginTab {
    component: React.ReactElement
}

export const ContractorTaxTypePluginTab = (props: IContractorTaxTypePluginTab): ITab => {
    return {
        id: uuidv4(),
        title: 'Изменение СНО',
        view: {
            content: <ContractorTaxTypePlugin plugin={'contractor_tax_type_plugin'} />
        }
    }
}